const capitalizeFirstLetter = (text) => {
  if (!text) return;
  const string = text;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export default capitalizeFirstLetter;
